// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//iview
import iView from 'iview';
import locale from 'iview/src/locale/lang/en-US'
import './theme/default.less'
import './theme/default.js'

//  clipboard
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

// Set AppKey
if(window.location.hostname === process.env.VUE_APP_HOSTNAME){
	window.key = process.env.VUE_APP_KEY;
	window.secret = process.env.VUE_APP_SECRET;
}else{
	window.key = "UKopHRt8f0zArH1V";
	window.secret = "fYhjB0RCTytsqP1C";
}

//Awesome
import 'font-awesome/less/font-awesome.less'

//vuex
import Vuex from 'vuex'
import store from './store/index'

//animate.css
import 'animate.css'

//jquery
import $ from 'jquery'

window.$ = $;
window.jQuery = $;


//lodash
import _ from 'lodash'

//svg icon
// import '@/assets/svg/iconfont.js'
// import '@/assets/svg/share-iconfont.js'

//hover.css
import 'hover.css/less/hover.less'

//wow.js
import WOW from 'wow.js';

//api list
import * as apiObj from './apilist/index'

Vue.use(iView);
Vue.use(router);
Vue.use(iView, {locale});
Vue.use(Vuex);

Vue.config.productionTip = false;


//wow function
Vue.prototype.$wow_init = function(){
	const wow = new WOW();
	wow.init();
};

// vue filter
Vue.filter('substr', (value, start, length)=>{
	let substr = value.substr(start, length);
	if(value.length > length - start){
		substr += "..."
	}
	return substr;
});

Object.defineProperties(Vue.prototype, {
	$fetch: {
		get(){
			return apiObj
		}
	}
});

/* eslint-disable no-new */
const app = new Vue({
	router,
	store,
	template: '<App/>',
	components: {App},
	created(){
		this.$nextTick(function(){
		})
	},
}).$mount("#bytelang");


//animateCss jQuery plugin
$.fn.extend({
	animateCss: function(animationName, callback){
		let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
		this.addClass('animated ' + animationName).one(animationEnd, function(){
			$(this).removeClass('animated ' + animationName);
			if(callback){
				callback();
			}
		});
		return this;
	}
});

//hoverCss jQuery plugin
$.fn.extend({
	hoverCss: function(animationName, callback){
		let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
		this.addClass(animationName).one(animationEnd, function(){
			//$(this).removeClass(animationName);
			if(callback){
				callback();
			}
		});
		return this;
	}
});

window.dd = function(...data){
	for(let i in data){
		console.log(data[i])
	}
};

if(process.env.VUE_APP_DEBUG === false){
	window.console.log = ()=>{
	};
	window.console.info = ()=>{
	};
	window.console.warn = ()=>{
	};
}

// module.exports = app;
